import { EligibilityGroupValues } from '../../../types/wizard-values';

export function isSpecificPeopleGroup(group: EligibilityGroupValues): boolean {
	return group && group.eligibilityFilters && group.eligibilityFilters.areSpecificPeopleSelected;
}
